import React, { useState, useEffect } from 'react';
import {
    Box, Typography, Stack, Button, Snackbar, Alert, Grid
} from '@mui/material';
import { DataGridPro, GridFooterContainer, GridPagination } from '@mui/x-data-grid-pro';
import { useLocation, useHistory } from 'react-router-dom';
import axios from "../../../../axios-order";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import SaveIcon from '@mui/icons-material/Save';
import { LoadingButton } from '@mui/lab';


const TdsChallanAssociate = () => {
    const location = useLocation();
    let history = useHistory()
    const [rows, setRows] = useState([]);
    const [selectionModel, setSelectionModel] = useState([]);
    const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'success' });
    const [pageSize, setPageSize] = useState(10);
    const [currentPage, setCurrentPage] = useState(0);
    const [challanItem, setChallanItem] = useState(location.state?.items || {});
    const [tdsAssociateDataloading, setTdsAssociateDataloading] = useState(false)
    const [associateSaveLoading, setAssociateLoading] = useState(false)
    const [hasSelectionChanged, setHasSelectionChanged] = useState(false);


    const getTdsAssociatedData = () => {
        setTdsAssociateDataloading(true)
        const endpoint = challanItem.challan_type === '24Q'
            ? '/get_unassociate_transaction_details'
            : challanItem.challan_type === '27Q'
                ? '/get_unassociate_transaction_details_27q'
            : '/get_unassociate_payble_recon';

        axios.post(endpoint, challanItem)
            .then((res) => {
                if (res.data?.status) {
                    const data = res.data.records || [];
                    setRows(data);

                    // Different selection logic for 24Q vs 26Q
                    let initialSelection;
                    if (challanItem.challan_type === '24Q') {
                        initialSelection = data
                            .filter(row => row.associated_remark === 'Associated')
                            .map(row => row.id);
                    } else if (challanItem.challan_type === '27Q') {
                        initialSelection = data
                            .filter(row => row.associated_remark === 'Associated')
                            .map(row => row.id);
                    } else {
                        // For 26Q: Select rows that ARE associated (is_associated: true)
                        initialSelection = data
                            .filter(row => row.is_associated === true)
                            .map(row => row.id);
                    }

                    setSelectionModel(initialSelection);
                    setHasSelectionChanged(false);
                }
            })
            .catch(() => {
            }).finally(() => {
                setTdsAssociateDataloading(false)
            });
    }

    useEffect(() => {
        getTdsAssociatedData()
    }, [challanItem]);


    const handleAssociateAndSave = () => {

        const selectedRows = rows.filter((row) => selectionModel.includes(row.id));

        const totalSelectedTDS = selectedRows.reduce((sum, row) => {
            if (challanItem.challan_type === '27Q') {
                if (row.associated_remark !== 'Associated') {
                    return sum + (row.net_tds || 0);
                }
                return sum;
            }
            if (challanItem.challan_type === '24Q') {
                // Only log and add if NOT already associated
                if (row.associated_remark !== 'Associated') {
                    const tdsAmount = row.tds_amount || 0;
                    const surchargeAmount = row.surcharge || 0;
                    const cessAmount = row.health_education_cess || 0;
                    const rowTotal = (row.tds_amount || 0) + (row.surcharge || 0) + (row.health_education_cess || 0);
                    console.log('Newly selected row - TDS:', row.tds_amount, '| Surcharge:', row.surcharge, '| Cess:', row.health_education_cess, '| Total:', rowTotal);
                    console.log('  TDS Amount:', tdsAmount);
                    console.log('  Surcharge:', surchargeAmount);
                    console.log('  Health & Education Cess:', cessAmount);
                    return sum + rowTotal;
                }
                // Skip already associated rows
                return sum;
            }
            return sum + ((!row.is_associated ? row.net_tds : 0) || 0);
        }, 0);

        console.log('Total of newly selected amounts:', totalSelectedTDS);
        const roundedTotalSelectedTDS = Math.round(totalSelectedTDS * 100) / 100;
        const remainingAmount = challanItem?.balance_payable || 0;
        const roundedRemainingAmount = Math.round(remainingAmount * 100) / 100;

        if (roundedTotalSelectedTDS > roundedRemainingAmount) {
            setSnackbar({
                open: true,
                message: `Selected TDS amount (₹${roundedTotalSelectedTDS.toLocaleString('en-IN')}) exceeds available challan amount (₹${roundedRemainingAmount.toLocaleString('en-IN')}).`,
                severity: 'warning'
            });
            return;
        }

        const updatedRows = rows.map((row) =>
            selectionModel.includes(row.id)
                ? { ...row, associated_remark: 'Associated', is_associated: true }
                : { ...row, associated_remark: '---', is_associated: false }
        );

        const payLoadData = challanItem.challan_type === '24Q'
            ? {
            business_entity_id: localStorage.getItem('business_entity_id'),
            repository_records: challanItem,
                tds_transaction_records: updatedRows  // For 24Q
            }
            : challanItem.challan_type === '27Q'
                ? {
                    business_entity_id: localStorage.getItem('business_entity_id'),
                    repository_records: challanItem,
                    tds_recon_records: updatedRows  // For 27Q
            }
            : {
                business_entity_id: localStorage.getItem('business_entity_id'),
                repository_records: challanItem,
                tds_recon_records: updatedRows  // For 26Q
        };
        setAssociateLoading(true);
        // Use different endpoint based on challanType
        const endpoint = challanItem.challan_type === '24Q'
            ? '/updated_associated_records_24q'
            : challanItem.challan_type === '27Q'
                ? '/updated_associated_records_27q'
            : '/updated_associated_challan_records';
        axios.post(endpoint, payLoadData)
            .then((res) => {
                if (res?.data?.status) {
                    setChallanItem((prev) => ({
                        ...prev,
                        associated_amount: res?.data?.associated_amount,
                        balance_payable: res?.data?.balance_payable
                    }));
                    setSnackbar({ open: true, message: 'Challan successfully associated.', severity: 'success' });
                } else {
                    setSnackbar({ open: true, message: res?.data?.message || 'Failed to associate.', severity: 'warning' });
                }
            })
            .catch(() => {
                setSnackbar({ open: true, message: 'Server error while saving association.', severity: 'error' });
            }).finally(() => {
                setAssociateLoading(false);
            });
    };



    const selectedTotal = rows
        .filter((row) => selectionModel.includes(row.id))
        .reduce((sum, row) => {
            if (challanItem.challan_type === '27Q') {
                return sum + ((!row.is_associated ? row.net_tds : 0) || 0);
            }
            if (challanItem.challan_type === '24Q') {
                return sum + (row.tds_amount || 0) + (row.surcharge || 0) + (row.health_education_cess || 0);
            }
            return sum + ((!row.is_associated ? row.net_tds : 0) || 0);
        }, 0);


    const columns = [
        { field: 'id', headerName: 'ID', hide: true },
        { field: 'name', headerName: 'Vendor', flex: 1 },
        { field: 'pan', headerName: 'PAN', flex: 1 },
        { field: 'bill_no', headerName: 'Invoice No', flex: 1 },
        { field: 'booking_date', headerName: 'Booking Date', flex: 1 },
        {
            field: 'tds_section', headerName: 'Section', flex: 1
        },
        {
            field: 'net_tds',
            headerName: 'TDS Payable',
            flex: 1,
            valueFormatter: ({ value }) => `₹${value?.toLocaleString('en-IN') || 0}`,
        },
        {
            field: 'associated_remark',
            headerName: 'Associated Remarks',
            flex: 1,
            renderCell: (params) => (
                <Typography variant="body2" color={params.value === 'Associated' ? 'green' : 'error'}>
                    {params.value || '--'}
                </Typography>
            )
        }
    ];

    const columns24Q = [
        { field: 'id', headerName: 'ID', hide: true },
        { field: 'name', headerName: 'Employee', flex: 1 },
        { field: 'pan', headerName: 'PAN', flex: 1 },
        { field: 'transaction_date', headerName: 'Transaction Date', flex: 1 },
        {
            field: 'tds_amount',
            headerName: 'TDS Amount',
            flex: 1,
            valueFormatter: ({ value }) => `₹${value?.toLocaleString('en-IN') || 0}`,
        },
        {
            field: 'payment_amount',
            headerName: 'Payment Amount',
            flex: 1,
            valueFormatter: ({ value }) => `₹${value?.toLocaleString('en-IN') || 0}`,
        },
        {
            field: 'surcharge',
            headerName: 'Surcharge',
            flex: 1,
            valueFormatter: ({ value }) => `₹${value?.toLocaleString('en-IN') || 0}`,
        },
        {
            field: 'health_education_cess',
            headerName: 'Health & Education Cess',
            flex: 1,
            valueFormatter: ({ value }) => `₹${value?.toLocaleString('en-IN') || 0}`,
        },
        {
            field: 'associated_remark',
            headerName: 'Associated Remarks',
            flex: 1,
            renderCell: (params) => (
                <Typography variant="body2" color={params.value === 'Associated' ? 'green' : 'error'}>
                    {params.value || '--'}
                </Typography>
            )
        }
    ];
    const columns27Q = [
        { field: 'id', headerName: 'ID', hide: true },
        { field: 'name', headerName: 'Name', flex: 1 },
        { field: 'pan', headerName: 'PAN', flex: 1 },
        { field: 'resident_non_resident', headerName: 'Resident / Non-Resident', flex: 1 },
        { field: 'bill_no', headerName: 'Invoice No', flex: 1 },
        { field: 'bill_date', headerName: 'Bill Date', flex: 1 },
        { field: 'tds_section', headerName: 'Section', flex: 1 },
        {
            field: 'net_tds', headerName: 'TDS Payable', flex: 1,
            valueFormatter: ({ value }) => `₹${value?.toLocaleString('en-IN') || 0}`,
        },
        {
            field: 'associated_remark', headerName: 'Associated Remarks', flex: 1,
            renderCell: (params) => (
                <Typography variant="body2" color={params.value === 'Associated' ? 'green' : 'error'}>
                    {params.value || '--'}
                </Typography>
            )
        }
    ];

    const handlePageChange = (newPage) => {
        setCurrentPage(newPage);
    };

    const handlePageSizeChange = (newPageSize) => {
        setPageSize(newPageSize);
    };

    function CustomFooter() {
        return (
            <GridFooterContainer sx={{ px: 2, py: 1 }}>
                <Stack
                    direction="row"
                    justifyContent="space-between"
                    alignItems="center"
                    width="100%"
                >
                    {/* Left: Total Selected */}
                    <Typography variant="subtitle1" fontWeight={700}>
                        Total Selected Amount: ₹{selectedTotal.toLocaleString('en-IN') || 0}
                    </Typography>

                    {/* Right: Default Pagination */}
                    <GridPagination />
                </Stack>
            </GridFooterContainer>
        );
    }


    return (
        <Box sx={{ p: 1, height: '70vh' }}>
            <Grid container alignItems="center" justifyContent="space-between" mb={2}>
                <Grid item xs="auto">
                    <Box
                        sx={{
                            backgroundColor: '#f0f4ff',
                            borderRadius: 2,
                            px: 3,
                            py: 2,

                            boxShadow: '0 2px 10px rgba(0,0,0,0.06)',
                            border: '1px solid #d0e2ff',
                        }}
                    >
                        <Stack
                            direction="row"
                            spacing={8}
                            alignItems="center"
                            flexWrap="wrap"
                            rowGap={2}
                        >
                            <Box>
                                <Typography variant="body2" color="text.secondary" sx={{ fontWeight: 500 }}>
                                    Challan Number
                                </Typography>
                                <Typography variant="subtitle1" fontWeight={600} color="text.primary">
                                    {challanItem.challan_no || '--'}
                                </Typography>
                            </Box>

                            <Box>
                                <Typography variant="body2" color="text.secondary" sx={{ fontWeight: 500 }}>
                                    Challan Amount
                                </Typography>
                                <Typography variant="subtitle1" fontWeight={600} color="text.primary">
                                    ₹{challanItem.repository_amount?.toLocaleString('en-IN') || '0'}
                                </Typography>
                            </Box>

                            <Box>
                                <Typography variant="body2" color="text.secondary" sx={{ fontWeight: 500 }}>
                                    Associated Amount
                                </Typography>
                                <Typography variant="subtitle1" fontWeight={600} color="text.primary">
                                    ₹{challanItem?.associated_amount?.toLocaleString('en-IN') || '0'}
                                </Typography>
                            </Box>
                            <Box>
                                <Typography variant="body2" color="text.secondary" sx={{ fontWeight: 500 }}>
                                    Balance Amount
                                </Typography>
                                <Typography variant="subtitle1" fontWeight={600} color="text.primary">
                                    ₹{challanItem?.balance_payable?.toLocaleString('en-IN') || '0'}
                                </Typography>
                            </Box>
                        </Stack>
                    </Box>

                </Grid>

                <Grid item>
                    <LoadingButton
                        variant="contained"
                        onClick={handleAssociateAndSave}
                        sx={{ textTransform: 'none', fontWeight: 500, ml: 2, }}
                        startIcon={<SaveIcon />}
                        loading={associateSaveLoading}
                        disabled={!hasSelectionChanged}
                    >
                        Save Association
                    </LoadingButton>
                    <Button
                        variant="contained"
                        // onClick={() => history.goBack()}
                        onClick={() => {
                            history.push({
                                pathname: '/TDSChallanRepository',
                                state: {
                                    returnedFromAssociation: true,
                                    previousView: challanItem?.previousView || 'unassociated'
                                }
                            });
                        }}
                        sx={{ textTransform: 'none', fontWeight: 500, marginLeft: 2 }}
                        startIcon={<ArrowBackIcon />}
                    >
                        Back
                    </Button>
                </Grid>
            </Grid>

            <DataGridPro
                rows={rows}
                columns={
                    challanItem.challan_type === '24Q'
                        ? columns24Q
                        : challanItem.challan_type === '27Q'
                            ? columns27Q
                            : columns
                }
                loading={tdsAssociateDataloading}
                checkboxSelection
                disableRowSelectionOnClick
                selectionModel={selectionModel}
                onSelectionModelChange={(newSelection) => {
                    if (!hasSelectionChanged) setHasSelectionChanged(true);
                    setSelectionModel(newSelection);
                }}
                getRowId={(row) => row.id}
                pagination
                pageSize={pageSize}
                pageSizeOptions={[5, 10, 25, 50]}
                onPageSizeChange={handlePageSizeChange}
                onPageChange={handlePageChange}

                sx={{
                    maxHeight: '60vh',

                    backgroundColor: '#fff',
                    '& .MuiDataGrid-columnHeader': {
                        backgroundColor: '#455a64',
                        color: '#fff',
                        fontWeight: 'bold',
                    },
                    '& .MuiDataGrid-columnHeader .MuiCheckbox-root': {
                        color: '#fff',
                    },
                    '& .MuiDataGrid-columnHeader .MuiCheckbox-root.Mui-checked': {
                        color: '#2196f3',
                    },
                    '& .MuiDataGrid-row:nth-of-type(odd)': {
                        backgroundColor: '#f9f9f9',
                    },
                    '& .MuiDataGrid-row:hover': {
                        backgroundColor: '#e3f2fd',
                        cursor: 'pointer'
                    },
                    "& .MuiDataGrid-sortIcon": {
                        opacity: 'inherit !important',
                    },
                    '& .MuiDataGrid-columnHeaderIcon': {
                        color: '#fff',
                    },
                    '& .MuiDataGrid-columnHeaders': {
                        '& .MuiDataGrid-columnHeader': {
                            '& .MuiDataGrid-menuIconButton': {
                                display: 'flex !important',
                                visibility: 'visible !important',
                                opacity: '1 !important',
                            },
                        },
                    },
                }}
                components={{
                    Footer: () => <CustomFooter selectedTotal={selectedTotal} />,
                }}
            />

            <Snackbar
                open={snackbar.open}
                autoHideDuration={3000}
                onClose={() => setSnackbar({ ...snackbar, open: false })}
                anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
            >
                <Alert severity={snackbar.severity} onClose={() => setSnackbar({ ...snackbar, open: false })}>
                    {snackbar.message}
                </Alert>
            </Snackbar>
        </Box>
    );
};

export default TdsChallanAssociate;
